module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/faq/faq.html
// module id = 794
// module chunks = 0